export default () => {
  let isLoad: boolean = false;

  (function() {
    var wf = document.createElement("script");
    wf.src =
      ("https:" == document.location.protocol ? "https" : "http") +
      "://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js";
    wf.type = "text/javascript";
    wf.async = true;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(wf, s);
  })();

  window["WebFontConfig"] = {
    google: {
      families: ["Lato:300,400,500,700", "Montserrat:300,500,700"]
    },
    classes: false,
    active: function() {
      isLoad = true;
    }
  };

  let time = 0;

  return new Promise<void>(res => {
    const interval = setInterval(() => {
      time += 20;
      if (isLoad || time > 5000) {
        res();
        clearInterval(interval);
      }
    }, 100);
  });
};
